import { register, find } from '../../../../Javascript/Sysmex/Utils'

const Radio = el => {
  const reloadUrl = el.dataset.reloadurl
  const componentPrefix = el.dataset.componentprefix
  if (!reloadUrl) {
    return false
  }
  const radio = find(`.${componentPrefix}radioField`, el)
  radio.addEventListener('change', (e) => {
    if (e.target.checked) {
      window.location.href = reloadUrl
    }
  })
}

register('Radio', Radio)
